import type { Main, Tabs as TabsProps } from '@ps/web-martech-cms-types';
import classNames from 'clsx';
import React from 'react';

import { CMSMain } from '@swf/cms';
import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';

import { TXTCLI_Tabs } from './CMSTabs.messages.json';
import styles from './CMSTabs.scss';

const CMSTabs: React.FC<TabsProps> = ({ tabs }) => {
  const [activeTab, setActiveTab] = React.useState<number>(0);
  const { formatMessage } = useRegulatoryIntl();

  return (
    <div role="tablist" aria-label={`CMS ${formatMessage(TXTCLI_Tabs)}`}>
      <div className={styles.panelTabs}>
        {tabs.map(({ tab }, index) => (
          <button
            key={index}
            role="tab"
            id={`tab-${index}`}
            aria-selected={activeTab === index}
            onClick={() => setActiveTab(index)}
            aria-controls={`tab-panel-${index}`}
            tabIndex={activeTab === index ? 0 : -1}
            style={{ backgroundColor: tab.background_color, color: tab.font_color }}
            className={classNames(styles.tab, { [styles.selectedTab]: activeTab === index })}
          >
            {tab.title}
          </button>
        ))}
      </div>
      <div className={styles.panel}>
        {tabs.map(
          ({ tab }, index) =>
            activeTab === index && (
              <div
                key={index}
                role="tabpanel"
                id={`tab-panel-${index}`}
                aria-labelledby={`tab-${index}`}
              >
                <CMSMain {...(tab as Main)} />
              </div>
            )
        )}
      </div>
    </div>
  );
};
export default CMSTabs;
